import { useState, useEffect } from 'react'
import { message } from 'antd'
import { GetKeyWordListAPI } from '@services/quality-inspection'
import { KeyWordItemType, KeyWordTypeEnum } from '@types'
import { get, groupBy } from 'lodash'

const customerService = KeyWordTypeEnum.customerService
const client = KeyWordTypeEnum.client

interface KeyWordListType {
  [customerService]: KeyWordItemType[],
  [client]: KeyWordItemType[]
};

const defKeyWordList: KeyWordListType = {
  [customerService]: [],
  [client]: [],
}

/**
 * 质检关键词 hook
 * @param isFitCascader 是否需要适配级联选择组件
 */
export const useKeyWordsList = (isFitCascader?: boolean) => {
  const [keyWordsList, setKeyWordsList] = useState(defKeyWordList)
  const [maxKeyWordCnt, setMaxKeyWordCnt] = useState(50)
  const [groupsList, setGroupsList] = useState([])
  /**
   * 获取客户关键词或客服关键词
   */
  const getKeyWordList = async () => {
    const [res, err] = await GetKeyWordListAPI()
    if (err) {
      message.error('获取关键词列表失败！')
    }
    const list = get(res, 'list', [])
    const groupsList = get(res, 'groupList', [])
    if (isFitCascader) {
      // 为什么 value 属性需要拼接【_groupId_, _id_】？
      // 因为级联选择组件的下拉选择框的 item 的 key 使用的是 value 属性，而 value 属性是唯一的，所以需要拼接上 groupId 和 id，避免重复
      // 单独使用关键词作为key，会导致级联选择组件的下拉选择框的 item 的 key 重复，导致下拉选择框的 item 显示异常
      groupsList.forEach(item => {
        item.label = item.groupName
        item.value = JSON.stringify(item?.list?.map(i => i.value) ?? []) + `_groupId_${item.groupId}`
        item.disabled = !item?.list?.length
        item.list.forEach(i => {
          i.label = i.value
          i.value = `${i.value}_id_${i.id}`
        })
      })
    }
    const newList = groupBy(list, 'type') as unknown as KeyWordListType
    const newGroupList = groupBy(groupsList, 'type')
    setGroupsList(newGroupList as unknown as any[])
    setKeyWordsList(newList)
    setMaxKeyWordCnt(get(res, 'maxKeyWordCnt', 50))
  }

  useEffect(() => {
    getKeyWordList()
  }, [])

  return { keyWordsList, defKeyWordList, getKeyWordList, maxKeyWordCnt, groupsList }
}
